import { useLanguage } from '../context/LanguageContext';
import sv from '../translations/sv.json';
import en from '../translations/en.json';
import de from '../translations/de.json';

const translations = {
  sv,
  en,
  de
};

export const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) return key; // Fallback to key if not found
    }
    
    return value || key;
  };

  return { t, language };
};